import React, { useEffect, useState } from "react";
import { getCalculationDataService } from "./services/dataService";

const CalculationControlComp = ({
  json,
  setJson,
  selectedQuestion,
  setActiveTab,
}) => {
  const [calculationData, setCalculationData] = useState([]);

  useEffect(() => {
    if (selectedQuestion.startsWith("page")) {
      setActiveTab(0);
    }
  }, [selectedQuestion]);

  useEffect(() => {
    if (!selectedQuestion.startsWith("page")) getCalculationData();
  }, [selectedQuestion]);

  const getCalculationData = async () => {
    const res = await getCalculationDataService();
    console.log("Res", res);
    if (res?.data?.status == "Success") {
      setCalculationData(res?.data?.result?.calculationData);
    }
  };

  console.log("JSON", json, selectedQuestion);
  const selectedElement = React.useMemo(() => {
    for (const page of json?.pages || []) {
      const found = page?.elements?.find((el) => el.id === selectedQuestion);
      if (found) return found;
    }
    return null;
  }, [json, selectedQuestion]);

  const calculationJson = selectedElement?.calculationJson || {};

  const updateCalcJson = (key, value) => {
    setJson((prev) => {
      const updatedPages = prev.pages.map((page) => {
        return {
          ...page,
          elements: page.elements.map((el) => {
            // ✅ ONLY update the selected element
            if (el.name === selectedQuestion) {
              return {
                ...el,
                calculationJson: {
                  ...(el.calculationJson || {}), // <-- preserve existing
                  [key]: value,
                },
              };
            }

            // ✅ ALL other elements remain untouched
            return el;
          }),
        };
      });

      return {
        ...prev,
        pages: updatedPages,
      };
    });
  };

  if (!selectedElement) return null;

  return (
    <>
      <div style={{ background: "white", padding: "15px" }}>
        {/* Calculation */}
        <div className="form-group">
          <label className="control-label">Calculation</label>
          <select
            className="form-control"
            value={calculationJson.calculation || ""}
            onChange={(e) => updateCalcJson("calculation", e.target.value)}
          >
            <option value="" disabled>
              Select a Calculation
            </option>

            {calculationData &&
              calculationData?.map((item, index) => (
                <option value={item.id} key={item.id}>
                  {index + 1 + ". " + item.name}
                </option>
              ))}
          </select>
        </div>

        {/* Has Value */}
        <div className="form-group">
          <label className="control-label">Has Value</label>
          <input
            className="form-control"
            placeholder="Select a value for parent components"
            value={calculationJson.hasValue || ""}
            onChange={(e) => updateCalcJson("hasValue", e.target.value)}
          />
        </div>
      </div>

      <hr />

      {/* DO Rule */}
      <div style={{ background: "white", padding: "15px" }}>
        <div className="form-group">
          <label className="control-label">Do</label>
          <select
            className="form-control"
            value={calculationJson.doRule ?? ""}
            onChange={(e) =>
              updateCalcJson(
                "doRule",
                e.target.value === "true"
                  ? true
                  : e.target.value === "false"
                    ? false
                    : -1,
              )
            }
          >
            <option value="" disabled>
              Select a child component behaviour
            </option>

            <option value="true">Show</option>
            <option value="false">Hide</option>
            <option value="-1">Disable</option>
          </select>
        </div>
      </div>
    </>
  );
};

export default React.memo(CalculationControlComp);
